import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DialogGenerateXML from './DialogGenerateXML';
import ButtonGenerateXML from './ButtonGenerateXML';
import ButtonDownloadXML from './ButtonDownloadXML';

const GenerateXML = ({ loading, periodicalReport = {} }) => {
  const { periodicalReportId } = useParams();
  const [modal, setModal] = useState(false);

  const permission = useSelector((state) => state?.session?.permissions?.['periodical-report-generator']);

  return (
    <>
      {permission?.['generate-xml'] &&
        
        ['closed'].includes(periodicalReport.status) && (
          <>
            {periodicalReport?.xml ? (
              <ButtonDownloadXML
                id={`generate-xml-${periodicalReportId}`}
                xml={periodicalReport?.xml}
                loading={loading}
                backgroundColor={'#b9f6ca'}
              />
            ) : (
              periodicalReport.isCurrent &&
              <ButtonGenerateXML
                id={`generate-xml-data-${periodicalReportId}`}
                loading={loading}
                onClick={() => setModal(true)}
              />
            )}
            <div className='px-1' />
          </>
        )}
      {modal && <DialogGenerateXML open={modal} onClose={() => setModal(false)} />}
    </>
  );
};

export default GenerateXML;
